import React, { useState } from 'react';
import type { EvaluationExam } from '@interactive-room';
import { resolveGuideHeaderPresentation } from './guideHeaderPresentation';

interface GuidePrintHeaderProps {
  exam: Pick<EvaluationExam, 'title' | 'linkedSession' | 'curriculumObjectives'>;
  subjectName?: string;
  docType: string;
  studyGuide: boolean;
  /** Nombre del colegio — masthead arriba-izquierda (sin Edusico). */
  schoolName?: string;
}

export function GuidePrintHeader({
  exam,
  subjectName,
  docType,
  studyGuide,
  schoolName,
}: GuidePrintHeaderProps) {
  const [curriculumOpen, setCurriculumOpen] = useState(false);
  const header = resolveGuideHeaderPresentation(exam, subjectName);
  const hasCurriculumGrid = header.curriculumGrid.length > 0;
  const schoolLabel = schoolName?.trim() || '';

  return (
    <header className="print-worksheet__masthead">
      <div className="print-worksheet__brand">
        {schoolLabel ? <span className="print-worksheet__logo">{schoolLabel}</span> : <span />}
        <span className="print-worksheet__doc-type">{docType}</span>
      </div>

      {header.curriculumBadge ? (
        <p className="print-worksheet__curriculum-badge" aria-label="Referencia curricular">
          {header.curriculumBadge}
        </p>
      ) : null}

      <h1 className="print-worksheet__title">{header.primaryTitle}</h1>

      {subjectName && !header.curriculumBadge?.includes(subjectName) ? (
        <p className="print-worksheet__subject">{subjectName}</p>
      ) : null}

      {hasCurriculumGrid ? (
        <section className="print-worksheet__curriculum-panel" aria-label="Ficha curricular MINEDUC">
          <button
            type="button"
            className="print-worksheet__curriculum-toggle no-print"
            aria-expanded={curriculumOpen}
            onClick={() => setCurriculumOpen((open) => !open)}
          >
            {curriculumOpen ? '▾' : '▸'} Ficha curricular MINEDUC
          </button>
          <div
            className={`print-worksheet__curriculum-grid${
              curriculumOpen ? ' print-worksheet__curriculum-grid--open' : ''
            }`}
            aria-hidden={!curriculumOpen}
          >
            {header.curriculumGrid.map((item) => (
              <div key={item.id} className="print-worksheet__curriculum-grid-item">
                <span className="print-worksheet__curriculum-grid-label">{item.label}</span>
                <span className="print-worksheet__curriculum-grid-value">{item.value}</span>
              </div>
            ))}
          </div>
        </section>
      ) : null}

      {!studyGuide ? (
        <div className="print-worksheet__fields">
          <label>
            Nombre <span className="print-field-line" />
          </label>
          {exam.curriculumObjectives?.levelLabel ? (
            <p className="print-worksheet__declared-course">
              Curso <strong>{exam.curriculumObjectives.levelLabel}</strong>
            </p>
          ) : (
            <label>
              Curso <span className="print-field-line print-field-line--short" />
            </label>
          )}
          <label>
            Fecha <span className="print-field-line print-field-line--short" />
          </label>
        </div>
      ) : null}
    </header>
  );
}
